import { Phone, Landmark } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF, WA_HREF, EMAIL_HREF, OWNER_EMAIL, WhatsAppIcon, scrollToId } from "@/lib/site";
import { T, useLang } from "@/lib/i18n";
import { Mail } from "lucide-react";

const SECTION_IDS = ["services", "fleet", "destinations", "booking", "contact"];

export default function Footer() {
  const { lang } = useLang();
  const t = T[lang].footer;
  const nav = T[lang].nav;

  return (
    <footer data-testid="footer" className="bg-[#16110C] text-white pt-20 pb-10 border-t border-stone-800/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center lg:items-start justify-between gap-12">
          <div className="flex flex-col items-center lg:items-start gap-4 max-w-sm text-center lg:text-left">
            <img src="/images/logo.webp" alt="Kumar Taxi & Tours Salzburg" className="h-24 w-24 rounded-2xl object-cover border border-[#C5A059]/30 shadow-lg shadow-black/40" />
            <p className="text-sm text-white/60 leading-relaxed">{t.tagline}</p>
          </div>

          <nav className="flex flex-col items-center lg:items-start gap-3" data-testid="footer-nav">
            <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#C5A059] mb-1">{t.explore}</p>
            {SECTION_IDS.map((id) => (
              <button
                key={id}
                data-testid={`footer-link-${id}`}
                onClick={() => scrollToId(id)}
                className="text-sm text-white/70 hover:text-[#C5A059] transition-colors duration-300"
              >
                {nav[id]}
              </button>
            ))}
          </nav>

          <div className="flex flex-col items-center lg:items-start gap-4">
            <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#C5A059] mb-1">{t.reach}</p>
            <a data-testid="footer-call-link" href={PHONE_HREF} className="flex items-center gap-2.5 text-sm text-white/80 hover:text-[#C5A059] transition-colors duration-300">
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
            <a data-testid="footer-whatsapp-link" href={WA_HREF} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-sm text-white/80 hover:text-[#25D366] transition-colors duration-300">
              <WhatsAppIcon className="w-4 h-4" /> WhatsApp {PHONE_DISPLAY}
            </a>
            <a data-testid="footer-email-link" href={EMAIL_HREF} className="flex items-center gap-2.5 text-sm text-white/80 hover:text-[#D64545] transition-colors duration-300">
              <Mail className="w-4 h-4" /> {OWNER_EMAIL}
            </a>
            <p className="text-xs text-white/40 mt-2">{t.availability}</p>
          </div>
        </div>

        <div className="gold-hairline mt-14 mb-8" />

        <div data-testid="footer-bank-details" className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 text-center mb-8">
          <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#C5A059]/10 border border-[#C5A059]/40">
            <Landmark className="w-4 h-4 text-[#C5A059]" />
          </span>
          <p className="text-xs text-white/50 leading-relaxed">
            <span className="text-white/70 font-semibold">{t.bankTitle}:</span> {t.bankText}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p data-testid="footer-impressum">Kumar Taxi &amp; Tours · Salzburg, Austria · Tel {PHONE_DISPLAY}</p>
          <p>{t.rights}</p>
        </div>
      </div>
    </footer>
  );
}
